import { Helmet } from 'react-helmet-async';
// @mui
import { Grid, Container, Typography, Card } from '@mui/material';

// Icons
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded';
import FoundationRoundedIcon from '@mui/icons-material/FoundationRounded';
import GiteRoundedIcon from '@mui/icons-material/GiteRounded';

// components

// sections
import { AppWidgetSummary } from '../sections/@dashboard/app';

import { app } from '../utils/app.config';

import Map from '../components/maps/Map';
import { useZakazky } from '../hooks/useZakazky';
import { useCallback } from 'react';
import { useFazy } from 'src/hooks/useFazy';

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const { zakazky } = useZakazky();
  const { statusSet, getStartingMonth, getStartingYear } = useFazy();

  const zakazkyCount = useCallback((state, data) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    const monthZakazky = data?.filter((item) => {
      const startingMonth = getStartingMonth(item);
      const startingYear = getStartingYear(item);

      return startingMonth === currentMonth && startingYear === currentYear;
    });

    if (data.length > 0 && Array.isArray(data)) {
      const itemsCreatedThisYear = data?.filter((item) => {
        return item?.year == currentYear;
      });

      switch (state) {
        case 'TOTAL':
          return data?.length.toString();
        case 'NAKLUC':
          return data?.length ? data.filter((item) => item.faza === 'na kľúč').length.toString() : '0';
        case 'HOLODOM':
          return data?.length ? data.filter((item) => item.faza === 'holodom').length.toString() : '0';
        case 'HRUBASTAVBA':
          return data?.length ? data.filter((item) => item.faza === 'hrubá stavba').length.toString() : '0';
        case 'ROK':
          return itemsCreatedThisYear?.length.toString();
        case 'MESIAC':
          return monthZakazky?.length.toString() ?? '0';
        case 'VPRIEBEHU':
          return (
            data
              ?.filter((item) => {
                return statusSet(item) === 'V priebehu';
              })
              .length.toString() ?? '0'
          );
      }
    }

    return '0';
  }, []);

  return (
    <>
      <Helmet>
        <title> Dashboard | {app.title} </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 2 }}>
          Počet zákaziek
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Celkovo"
              total={zakazkyCount('TOTAL', zakazky)}
              icon={<EngineeringRoundedIcon />}
              to="/sprava/zakazky/?page=0&rows=25"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="V tomto roku"
              total={zakazkyCount('ROK', zakazky)}
              color="info"
              icon={<EngineeringRoundedIcon />}
              to="/sprava/zakazky/?show=year&page=0&rows=25"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="V tomto mesiaci"
              total={zakazkyCount('MESIAC', zakazky)}
              color="warning"
              icon={<EngineeringRoundedIcon />}
              to="/sprava/zakazky/?show=month&page=0&rows=25"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary
              title="Aktuálne v priebehu"
              total={zakazkyCount('VPRIEBEHU', zakazky)}
              color="warning"
              icon={<EngineeringRoundedIcon />}
              to="/sprava/zakazky/?show=progress&page=0&rows=25"
            />
          </Grid>
        </Grid>
        <Typography variant="h4" sx={{ mb: 2, mt: 4 }}>
          Počet stavieb
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <AppWidgetSummary
              title="Hrubá stavba"
              total={zakazkyCount('HRUBASTAVBA', zakazky)}
              icon={<FoundationRoundedIcon />}
              to="/sprava/zakazky/?show=hruba&page=0&rows=25"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AppWidgetSummary
              title="Holodom"
              total={zakazkyCount('HOLODOM', zakazky)}
              color="info"
              icon={<GiteRoundedIcon />}
              to="/sprava/zakazky/?show=holodom&page=0&rows=25"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AppWidgetSummary
              title="Na kľúč"
              total={zakazkyCount('NAKLUC', zakazky)}
              color="warning"
              icon={<VpnKeyRoundedIcon />}
              to="/sprava/zakazky/?show=kluc&page=0&rows=25"
            />
          </Grid>
        </Grid>
        <Typography variant="h4" sx={{ mb: 2, mt: 4 }}>
          Mapa s aktuálnymi stavbami / zákazkami
        </Typography>
        <Card sx={{ p: 1, mt: 2, mb: 2 }}>
          <Map zoom={8} position={{ lat: 48.669, lng: 19.699 }} height="600px" zakazky={zakazky} currentYear={true} />
        </Card>
      </Container>
    </>
  );
}
